<template>
  <m-geo-box geo-option="congressionalDistrict">
    <m-geo-select :geoType="22" :changeGeoType="22"></m-geo-select>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MGeoSelect from '@/components/geo/MGeoSelect'
  export default {
    components: {
      MGeoBox,
      MGeoSelect
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/order/GeoCongressionalDistrict.vue